<div class="summary-charts">
    <div class="summary-charts__chart">
        @if (hasData()) {
        @defer {
        <div echarts [options]="options" class="demo-chart"></div>
        } @placeholder {
        <div echarts [options]="options" [loading]="true" class="demo-chart"></div>
        }
        } @else {
        <div class="summary-charts__empty">
            No time tracks available for this week
        </div>
        }
    </div>
</div>
